require('./expensesSummaryBoxHeader.scss');

// @vendors
import React from 'react';
import PropTypes from 'prop-types';
const classnames = require('classnames');


// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @utilities
const moment = require('moment');
const { FormattedText, formatText } = require('core/i18n').i18n;
const { toFirstUppercase, toCamelCase } = require('utilities/stringHelper');
const { formatAmount, formatCurrency } = require('utilities/currencyHelper');

// @images
const openTutorialImg = require('assets/images/icon-tutorial.svg');


const ExpensesSummaryBoxHeader = ({currentTotal, prevTotal, currency, onFilterClick}) => {
    const currentMonth = toFirstUppercase(moment().startOf('month').format('MMMM'));
    const prevMonth = toFirstUppercase(moment().startOf('month').subtract(1, 'month').format('MMMM'));
    const filterButtonTooltipText = toCamelCase(formatText('myGlobalPositionExpenses-filterButtonTooltipText'));
    const tutorialTooltipTarget = <img src={openTutorialImg} className="expenses-summary-box__header__tooltip" /> ;
    const currentMonthStyles = classnames('expenses-summary-box__header__expenses--month', {
        'compare': !!prevTotal
    });

    const filterButton = (
        <div className="expenses-summary-box__header__filter-button">
            <OKButton
                modifier="task"
                inverse={true}
                onClick={onFilterClick}
            >
                <i className="icon-filtrar" />
            </OKButton>
        </div>
    );

    const buildPrevMonthExpenses = (
        <h3 className="expenses-summary-box__header__expenses">
            <span className="expenses-summary-box__header__expenses--month compare">
                <span className="bullet prev"></span>
                {prevMonth}
            </span>
            <span className="expenses-summary-box__header__expenses--prev-total" >
                {formatAmount(prevTotal)}{' '}
                {formatCurrency(currency)}
            </span>
        </h3>
    );

    return (
        <div className="expenses-summary-box__header">
            <OKTooltip
                content={filterButtonTooltipText}
                offset={[0, -15]}
                target={filterButton}
                type="descriptive"
                />  
            <h3 className="expenses-summary-box__header__title">
                <FormattedText value="globalPositionExpenses-thisMonthExpenses" />
                <OKTooltip
                    content="globalPositionExpenses-expensesByCategoryTooltip"
                    offset={[0, -15]}
                    target={tutorialTooltipTarget}
                />
            </h3>
            <h3 className="expenses-summary-box__header__filter-type">
                <FormattedText value={`globalPositionExpenses-ALL`} />
            </h3>
            <h3 className="expenses-summary-box__header__expenses">
                <span className={currentMonthStyles}>
                    <span className="bullet"></span>
                    {currentMonth}
                </span>
                <span className="expenses-summary-box__header__expenses--total" >
                    {formatAmount(currentTotal)}{' '}
                    {formatCurrency(currency)}
                </span>
            </h3>
            {!!prevTotal && buildPrevMonthExpenses}
        </div>
    );
}

ExpensesSummaryBoxHeader.propTypes = {
    currentTotal: PropTypes.number.isRequired, 
    prevTotal: PropTypes.number.isRequired,
    currency: PropTypes.string, 
    onFilterClick: PropTypes.func,
};
 
export default ExpensesSummaryBoxHeader;